import { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardFooter, CardHeader, Input, Select, Switch } from '@/components/ui'
import { useT } from '@/internationalization/i18n'
import { useWorkspaceSettings } from '../hooks'

// Disclosure is hidden from the Workspace page for now. The section below is left
// intact (and its settings keep working) - flip this to true to show it again.
const SHOW_DISCLOSURE_SECTION = false

export function WorkspaceSettings() {
  const t = useT()
  const { query, save } = useWorkspaceSettings()
  const data = query.data
  const [name, setName] = useState('')
  const [domain, setDomain] = useState('')

  useEffect(() => {
    if (!data) return
    setName(data.name)
    setDomain(data.domain)
  }, [data])

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader title={t('workspace.title')} description={t('workspace.description')} />
        <CardBody className="grid gap-4 sm:grid-cols-2">
          <Input
            label={t('workspace.name')}
            value={name}
            onChange={(event) => setName(event.target.value)}
            hint={t('workspace.nameHint')}
          />
          <Input
            label={t('workspace.verifiedDomain')}
            value={domain}
            onChange={(event) => setDomain(event.target.value)}
            hint={t('workspace.verifiedDomainHint')}
          />
          <Select
            label={t('workspace.dataResidency')}
            options={[
              { value: 'ap-south-1', label: t('workspace.region.ap') },
              { value: 'eu-west-1', label: t('workspace.region.eu') },
              { value: 'us-east-1', label: t('workspace.region.us') },
            ]}
            defaultValue={data?.region ?? 'ap-south-1'}
            // Moving a tenant's region is a migration, not a setting.
            disabled
            hint={t('workspace.dataResidencyHint')}
          />
          <Input label={t('workspace.recorderName')} defaultValue="Sabha AI" hint={t('workspace.recorderNameHint')} />
        </CardBody>
        <CardFooter>
          <Button
            variant="primary"
            isLoading={save.isPending}
            disabled={!name.trim()}
            onClick={() => save.mutate({ name: name.trim(), domain: domain.trim() })}
          >
            {t('common.saveChanges')}
          </Button>
        </CardFooter>
      </Card>

      {SHOW_DISCLOSURE_SECTION && (
        <Card>
          <CardHeader
            title={t('workspace.disclosureTitle')}
            description={t('workspace.disclosureDesc')}
          />
          <CardBody className="space-y-4">
            <Switch
              label={t('workspace.announceRecording')}
              description={t('workspace.announceRecordingDesc')}
              showLabel
              checked
              onChange={() => undefined}
            />
            <Switch
              label={t('workspace.requireExternalTold')}
              description={t('workspace.requireExternalToldDesc')}
              showLabel
              checked={false}
              onChange={() => undefined}
            />
          </CardBody>
        </Card>
      )}
    </div>
  )
}
